import React from "react";
import { motion } from "framer-motion";
import Icon1 from "../Images/too-many-leads-icon.svg";
import Icon2 from "../Images/missing-out-on-sales-chat-icon.svg";
import Icon3 from "../Images/cant-track-whats-working-icon.svg";
import Icon4 from "../Images/need-help-with-automation-icon.svg";
import Dashboard from "../Images/too-many-leads.webp";
import Chat from "../Images/need-help-with-automation.webp";

// Stagger container for grid elements
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.12,
      delayChildren: 0.1,
    },
  },
};

// Standard clean fade-up animation
const fadeUpVariants = {
  hidden: {
    opacity: 0,
    y: 30,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.25, 0.1, 0.25, 1],
    },
  },
};

const FeatureSection = () => {
  return (
    <section className="feature-section">
      <div className="container">

        {/* Heading Section */}
        <div className="feature-heading">

          <motion.div
            className="feature-left"
            variants={fadeUpVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <h2 className="section-heading">
              An entire operating system
              <br />
              for <span>conversations.</span>
            </h2>
          </motion.div>

          <motion.div
            className="feature-right"
            variants={fadeUpVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <p className="section-text">
              Everything your enterprise needs to automate conversations,
              manage customer engagement, analyze performance, and scale
              WhatsApp operations—all without writing a single line of code.
            </p>
          </motion.div>

        </div>

        {/* Feature Grid Section */}
        <motion.div
          className="feature-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.15 }}
        >

          {/* Card 1 */}
          <motion.div
            variants={fadeUpVariants}
            whileHover={{ y: -6 }}
            transition={{ duration: 0.2 }}
            className="feature-card large-card"
          >
            <div className="card-icon-wrapper">
              <img
                src={Icon1}
                alt="Too many leads, not enough time icon | Onbbits"
                className="card-icon"
              />
            </div>

            <h3 className="card-heading">
              Too many leads,
              <br />
              not enough time?
            </h3>

            <p className="section-text">
              You spent money getting them to message. ONBBITS auto-replies
              before your team even opens the app.
            </p>

            <img
              src={Dashboard}
              alt="Too many leads, not enough time? | Onbbits"
              className="card-image dashboard-img"
            />
          </motion.div>

          {/* Card 2 */}
          <motion.div
            variants={fadeUpVariants}
            whileHover={{ y: -6 }}
            transition={{ duration: 0.2 }}
            className="feature-card dark-card"
          >
            <div className="card-icon-wrapper">
              <img
                src={Icon2}
                alt="Missing out on sales chats icon | Onbbits"
                className="card-icon"
              />
            </div>

            <h3 className="card-heading">
              Missing out on sales chats?
            </h3>

            <p className="section-text">
              Every incoming message in one shared inbox.
              Every agent knows exactly what to reply and when.
            </p>
          </motion.div>

          {/* Card 3 */}
          <motion.div
            variants={fadeUpVariants}
            whileHover={{ y: -6 }}
            transition={{ duration: 0.2 }}
            className="feature-card card-white"
          >
            <div className="card-icon-wrapper">
              <img
                src={Icon3}
                alt="Can't track what's working icon | Onbbits"
                className="card-icon"
              />
            </div>

            <h3 className="card-heading">
              Can't track what's working?
            </h3>

            <p className="section-text">
              See open rates, delivery, replies and conversions
              per campaign in real time—not spreadsheets.
            </p>
          </motion.div>

          {/* Card 4 */}
          <motion.div
            variants={fadeUpVariants}
            whileHover={{ y: -6 }}
            transition={{ duration: 0.2 }}
            className="feature-card green-card"
          >
            <div className="card-content">
              <div className="card-icon-wrapper">
                <img
                  src={Icon4}
                  alt="Need help with automation icon | Onbbits"
                  className="card-icon"
                />
              </div>

              <h3 className="card-heading">
                Need help with
                <br />
                automation?
              </h3>

              <p className="section-text">
                We help you build it.
                On the demo call we set up your first
                automation flow live.
              </p>
            </div>

            <img
              src={Chat}
              alt="Need help with automation? | Onbbits"
              className="card-image phone-img"
            />
          </motion.div>

        </motion.div>

      </div>
    </section>
  );
};

export default FeatureSection;